// Glasses-mode detection. A device is treated as "glasses" when there's a
// LIVE signal on the current request:
//   1. ?glasses=1 / ?view=glasses query param (baked into the GlassApps URL)
//   2. A glasses path: /glasses, /glasses-login, /display, /meta (or /glasses/*)
//   3. User-agent sniff for known Meta Ray-Ban Display strings (best-effort)
//
// NB: detection is intentionally NOT persisted. An earlier version stashed a
// sticky flag in sessionStorage so the chrome survived navigation, but that
// trapped a normal user who hit a glasses URL once (e.g. ?glasses=1 or a
// peek at /display) — every later view in that tab stayed in glasses mode
// until the tab closed. Every signal above is re-checked live instead, so
// navigating to a normal route instantly returns the normal app. The glasses
// browser keeps its glasses URL (/display bookmark or ?glasses=1) in the
// address bar throughout pairing/login, so a live check is sufficient.

function uaLooksLikeGlasses(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = (navigator.userAgent || '').toLowerCase();
  // Meta Ray-Ban Display browser identifies itself with these markers in
  // most builds; harmless if it picks up nothing (URL/param fallback).
  return /meta(?:quest|wearable|displayos)|ray.?ban|rayban|glassapps/.test(ua);
}

function hasLiveGlassesSignal(): boolean {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname;
  if (path === '/glasses' || path === '/glasses-login' || path === '/display'
      || path === '/meta' || path.startsWith('/glasses/')) {
    return true;
  }
  const params = new URLSearchParams(window.location.search);
  if (params.get('glasses') === '1' || params.get('view') === 'glasses') return true;
  return uaLooksLikeGlasses();
}

export function isGlassesMode(): boolean {
  return hasLiveGlassesSignal();
}

// Kept as a separate name for call-site clarity (deciding whether to replace
// the authed app shell with the HUD), but now identical to isGlassesMode —
// there's no longer a sticky-vs-live distinction to draw.
export function shouldRenderGlassesShell(): boolean {
  return hasLiveGlassesSignal();
}
